import { AxiosInstance } from "axios";
import { IIdentity } from "./types";

const getIdentity = async (
  id: string | number,
  authenticatedRequest: AxiosInstance
) => authenticatedRequest.get<IIdentity>(`/api/v2/identities/${id}`);

export { getIdentity };
